import React from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Portlet, PortletContent } from '../../../../../components';
import ListagemPlanosParametrosTablePagination from './ListagemPlanosParametrosTablePagination';
import { ListagemPlanosTableRow } from './ListagemPlanosTableRow';
import { ListagemPlanosTableRowStyles } from '../ListagemPlanos.style';
import TableColumnSortButton from '../../../../../theme/components/TableColumnSortButton/TableColumnSortButton';

const useStyles = makeStyles(ListagemPlanosTableRowStyles);

export default function ListagemPlanosParametrosTable(props) {
  const classes = useStyles(props);
  const {
    data: plans,
    total,
    currentPage,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    setSorts,
    sorts,
    onEdit,
  } = props;
  const rootClassName = cls(classes.root);

  return (
    <Portlet className={rootClassName}>
      <PortletContent noPadding>
        <Table width="100%" className={classes.mainTable}>
          <TableHead className={classes.tableHead}>
            <TableRow className={classes.rowShadow}>
              <TableCell className={classes.tableCell} width="25%">
                <Typography variant="caption" style={{ fontSize: '13px', fontWeight: 700, color: '#000' }}>
                  Nome do Plano
                  <TableColumnSortButton value={sorts?.name || ''} onChange={sort => setSorts({ name: sort })} />
                </Typography>
              </TableCell>

              <TableCell className={classes.tableCell} width="27%">
                <Typography variant="caption" style={{ fontSize: '13px', fontWeight: 700, color: '#000' }}>
                  Descrição
                </Typography>
              </TableCell>

              <TableCell className={classes.tableCell} width="13%">
                <Typography variant="caption" style={{ fontSize: '13px', fontWeight: 700, color: '#000' }}>
                  Data de Criação
                  <TableColumnSortButton
                    value={sorts?.createdAt || ''}
                    onChange={sort => setSorts({ createdAt: sort })}
                  />
                </Typography>
              </TableCell>

              <TableCell className={classes.tableCell} width="18%">
                <Typography variant="caption" style={{ fontSize: '13px', fontWeight: 700, color: '#000' }}>
                  Resumo
                </Typography>
              </TableCell>

              <TableCell className={classes.tableCell} width="7%">
                <Typography variant="caption" style={{ fontSize: '13px', fontWeight: 700, color: '#000' }}>
                  Ações
                </Typography>
              </TableCell>

              <TableCell className={classes.tableCell} width="3%" />
            </TableRow>
          </TableHead>

          <TableBody>
            {!plans || plans.length === 0 ? (
              <TableRow width="100%" className={classes.tr}>
                <TableCell className={classes.tableCell} colSpan={6}>
                  Ops. Não encontramos nada.
                </TableCell>
              </TableRow>
            ) : (
              plans.map(row => {
                return (
                  <ListagemPlanosTableRow
                    key={row.publicId || row.id}
                    planData={row}
                    classes={classes}
                    onEdit={onEdit}
                  />
                );
              })
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                count={total}
                page={currentPage - 1}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Registros por página"
                onPageChange={() => {}}
                ActionsComponent={() => (
                  <ListagemPlanosParametrosTablePagination
                    total={total}
                    onChangePage={handleChangePage}
                    page={currentPage}
                    rowsPerPage={rowsPerPage}
                  />
                )}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </PortletContent>
    </Portlet>
  );
}

ListagemPlanosParametrosTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  handleChangeRowsPerPage: PropTypes.func.isRequired,
  setSorts: PropTypes.func.isRequired,
  sorts: PropTypes.shape({
    name: PropTypes.string,
    createdAt: PropTypes.string,
  }).isRequired,
  onEdit: PropTypes.func,
};

ListagemPlanosParametrosTable.defaultProps = {
  onEdit: null,
};
